import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import cn from "classnames";

function AddOrderButton({noOrders = true}) {
    return (
        <Link to="/new"
              className={cn("btn btn-primary text-light btn-add-order d-flex justify-content-center align-items-center shadow", {"pulse": noOrders})}>
            <FontAwesomeIcon className="fs-1" icon={["fas", "plus"]}/>
        </Link>
    )
}

export default AddOrderButton